import selectors from '../../../../rootSelectors';
import { goToPassage, goToCountdown, goToInterstitial } from '../../../../common/navigation/navigationActions';
import {
    RCT, FLUENCY, COMPREHENSION, FLUENCY_COMPREHENSION,
} from '../../../../constants/measure';
import {
    showQuestion, hideQuestion, hideSegment, showSegment, setIsReadyScriptPlayed,
    discontinueFluencyComprehension, recreateFluCompResults,
} from '../../../rctActions';
import { activateNextButton, greyOutScreen, unblockScreen } from '../../../../common/screen/screenActions';
import { playAvatarAudio, setAvatarInstructions } from '../../../../common/avatar/avatarActions';
import RCT_AUDIO_INSTRUCTIONS from '../../../rctConstants';
import { PASSAGE } from '../../../../constants/assessmentItemType';
import {  activateReadyForNextScreen } from '../../../../common/questions/questionsActions';
import { setPlaylistItemCompleted } from '../../../../common/playlist/playlistActions';
import { startQuestionTimeTracking } from '../../../../common/timeTracking/timeTrackingActions';
import { STATUS } from '../../../../constants/result';

const FLUENCY_AUDIO = RCT_AUDIO_INSTRUCTIONS.FLUENCY;

export const narrateNextButtonScript = () => (dispatch) => dispatch(playAvatarAudio([FLUENCY_AUDIO.passageComplete]));

export const showNextSegment = (activePassageIndex) => (dispatch, getState) => {
    const state = getState();
    if (selectors.hasNextSegment(state, PASSAGE, activePassageIndex)) {
        const nextSegmentIndex = selectors.getActiveSegmentIndex(state) + 1;
        dispatch(showSegment(nextSegmentIndex));
    }
};

export const onNextButtonClick = (activePassageIndex) => (dispatch, getState) => {
    const state = getState();
    if (!selectors.getQuestionsIsReadyForNextScreen(state)) {
        dispatch(setIsReadyScriptPlayed(true));
        dispatch(goToCountdown(RCT, FLUENCY, activePassageIndex + 1));
    } else {
        dispatch(setIsReadyScriptPlayed(false));
        dispatch(goToPassage(RCT, COMPREHENSION, activePassageIndex + 1));
    }
};

export const showNextElement = (activePassageIndex) => (dispatch, getState) => {
    const state = getState();
    if (selectors.hasQuestion(state, PASSAGE, activePassageIndex)) {
        dispatch(showQuestion());
    } else {
        dispatch(showNextSegment(activePassageIndex));
    }
};

export const showNavigationButton = () => (dispatch) => {
    dispatch(greyOutScreen());
    dispatch(activateReadyForNextScreen());
    dispatch(activateNextButton());
    dispatch(narrateNextButtonScript())
        .then(() => {
            dispatch(setAvatarInstructions(FLUENCY_AUDIO.clickOk));
            dispatch(unblockScreen());
        });
};

export const showNextSection = (passageHasQuestion, activePassageIndex) => (dispatch, getState) => {
    const state = getState();
    if (!selectors.hasNextSegment(state, PASSAGE, activePassageIndex)) {
        dispatch(showNavigationButton());
    } else {
        dispatch(hideSegment());
        dispatch(showNextElement(activePassageIndex));
        if (!passageHasQuestion) {
            dispatch(startQuestionTimeTracking());
        }
        dispatch(unblockScreen());
    }
};

export const discontinueStudent = () => (dispatch) => dispatch(discontinueFluencyComprehension())
    .then(() => {
        dispatch(setPlaylistItemCompleted(FLUENCY_COMPREHENSION));
        dispatch(goToInterstitial());
    });

export const checkForDiscontinue = (activePassageIndex) => (dispatch, getState) => {
    const state = getState();

    if (selectors.isDiscontinueRCTIncorrectQuestionRule(state, activePassageIndex)) {
        return dispatch(discontinueStudent());
    }
    dispatch(hideQuestion());
    return Promise.resolve();
};

export const playReadyScript = () => (dispatch, getStore) => {
    const state = getStore();
    const isReadyScriptPlayed = selectors.getIsReadyScriptPlayed(state);
    if (!isReadyScriptPlayed) {
        dispatch(greyOutScreen());
        return dispatch(playAvatarAudio(FLUENCY_AUDIO.ready))
            .then(() => {
                dispatch(activateNextButton());
            });
    }

    // Start the response timer if the ready script has already been played
    dispatch(startQuestionTimeTracking());
    return Promise.resolve();
};

export const recreateFluencyComprehensionResults = () => (dispatch, getStore) => {
    const state = getStore();
    const nextPlaylistItem = selectors.getNextIncompleteMeasure(state);
    // Resume on page refresh (Issue NOM-3728)
    const isFluCompMeasureInProgress = (nextPlaylistItem !== undefined
            && nextPlaylistItem.key === FLUENCY_COMPREHENSION
            && nextPlaylistItem.status === STATUS.IN_PROGRESS);

    if (isFluCompMeasureInProgress) {
        return dispatch(recreateFluCompResults());
    }
    return Promise.resolve();
};
